export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "static/js/binder.worker.b253bc17.worker.js");
}
